// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__tCJdb","lds-roller":"Loading_lds-roller__5rfuC"};